import apiConfig from "@/config/apiConfig";
const rootPath = apiConfig.commonApi;
const webPath = apiConfig.financeApi;


//知识产权   服务机构
export const innovationMechanismInfo = {
    pageList: webPath + "/innovationMechanismInfo/pageList", // 分页数据(get)
    detail: webPath + "/innovationMechanismInfo/detailId", // 详情(get)
};

//知识产权   服务机构
export const knowledgePropertyTransactionWeb = {
    pageList: webPath + "/knowledgePropertyTransaction/pageList", // 分页数据(get)
    detail: webPath + "/knowledgePropertyTransaction/detail", // 详情(get)
    analyse: webPath + "/knowledgePropertyTransaction/analyse", // 详情(get)
};

//知识产权   版权
export const knowledgeCopyrightWeb = {
    pageList: webPath + "/knowledgeCopyright/pageList", // 分页数据(get)
    detail: webPath + "/knowledgeCopyright/detail", // 详情(get)
};

//知识产权   专利
export const knowledgePatentWeb = {
    pageList: webPath + "/knowledgePatent/pageList", // 分页数据(get)
    detail: webPath + "/knowledgePatent/detail", // 详情(get)
};



//知识产权   商标
export const brandApi = {
    saveOrUpdate: rootPath + "/knowledgeBrand/saveOrUpdate", // 新增或者编辑数据(post)
    pageList: rootPath + "/knowledgeBrand/pageList", // 分页数据(get)
    detail: rootPath + "/knowledgeBrand/detail", // 详情(get)
    list: rootPath + "/knowledgeBrand/list", // 无分页数据(get)
    remove: rootPath + "/knowledgeBrand/remove/", // 根据id删除-批量删除(delete)
};
//知识产权   版权
export const copyrightApi = {
    saveOrUpdate: rootPath + "/knowledgeCopyright/saveOrUpdate", // 新增或者编辑数据(post)
    pageList: rootPath + "/knowledgeCopyright/pageList", // 分页数据(get)
    detail: rootPath + "/knowledgeCopyright/detail", // 详情(get)
    list: rootPath + "/knowledgeCopyright/list", // 无分页数据(get)
    remove: rootPath + "/knowledgeCopyright/remove/", // 根据id删除-批量删除(delete)
};
//知识产权   专利
export const patentApi = {
    saveOrUpdate: rootPath + "/knowledgePatent/saveOrUpdate", // 新增或者编辑数据(post)
    pageList: rootPath + "/knowledgePatent/pageList", // 分页数据(get)
    detail: rootPath + "/knowledgePatent/detail", // 详情(get)
    list: rootPath + "/knowledgePatent/list", // 无分页数据(get)
    remove: rootPath + "/knowledgePatent/remove/", // 根据id删除-批量删除(delete)
};
//知识产权   交易
export const tradeApi = {
    saveOrUpdate: rootPath + "/knowledgePropertyTransaction/saveOrUpdate", // 新增或者编辑数据(post)
    pageList: rootPath + "/knowledgePropertyTransaction/pageList", // 分页数据(get)
    pagelistPurchase: rootPath + "/knowledgePropertyTransaction/pagelistPurchase", // 购买、意向==》分页查询(get)
    detail: rootPath + "/knowledgePropertyTransaction/detail", // 详情(get)
    list: rootPath + "/knowledgePropertyTransaction/list", // 无分页数据(get)
    remove: rootPath + "/knowledgePropertyTransaction/remove/", // 根据id删除-批量删除(delete)
    verify: rootPath + "/knowledgePropertyTransaction/verify/", // 平台方==》审核产权交易
    sellerCancel: rootPath + "/knowledgePropertyTransaction/sellerCancel/", // 出售方==》取消产权交易
    purchaserCancel: rootPath + "/knowledgePropertyTransaction/purchaserCancel/", // 购买方==》取消产权交易
    publish: rootPath + "/knowledgePropertyTransaction/publish/", // 出售方==》发布产权交易
    affirm: rootPath + "/knowledgePropertyTransaction/affirm/", // 出售方==》确认产权交易
    pageListIntention: rootPath + "/knowledgePropertyTransactionIntention/pageListIntention/", // 产权交易订单号查询意向客户分页查询
    zxsaveOrUpdate: rootPath + "/knowledgePropertyTransactionIntention/saveOrUpdate", // 交易咨询

};
export const TransactionIntention = {
    remove: rootPath + "/knowledgePropertyTransaction/remove/", // 根据id删除-批量删除(delete)

};
